export default {
  label: "SSH",
  placeholder: "ssh user@example.com",
  add: "Add SSH server",
  "server.menu.label": "SSH server",
  target: "Host or SSH command",
  connect: "Connect",
  connectTo: "Connect to {{host}}",
  authenticate: "SSH authentication",
  "session.disconnected": "SSH connection inactive",
  "session.connecting": "Connecting to SSH server",
  "session.reconnectDescription":
    "Reconnect to view this session and continue working. Your remote session is preserved.",
  "session.reconnect": "Reconnect",
  trust: "Trust and connect",
  continue: "Continue",
  update: "Update and reconnect",
  project: "Open project on {{host}}",
  "stage.incompatible": "Server update required",
  "error.input": "Enter a host or SSH connection command. Remote commands and unsupported SSH options aren’t allowed.",
  "error.connection": "Could not establish the SSH connection. Check your network and SSH configuration.",
  "error.platform":
    "This remote platform is not supported. Automatic setup currently requires Linux or macOS on x64 or arm64.",
  "error.version": "The remote service must match this Desktop version before connecting.",
  "error.install": "Could not install the remote server. Check connectivity, disk space, and that tar is installed.",
  "error.unpublished":
    "This Desktop version has no published remote server. For development builds, install and start V2 on the host, then retry.",
  "error.service": "SSH connected, but the OpenCode server did not become ready.",
  "error.host-key":
    "The host’s identity could not be verified. Verify its fingerprint before updating your SSH known hosts.",
  "error.ssh-missing": "OpenSSH was not found. Install an OpenSSH client and ensure ssh is available on PATH.",
  "error.unavailable": "SSH is unavailable",
  "action.authenticate": "Authenticate",
  "stage.connecting": "Connecting over SSH…",
  "stage.authentication": "Authentication required",
  "form.name": "Server name (optional)",
  "form.namePlaceholder": "Localhost",
  "form.add": "Add server",
  "menu.delete": "Delete",
}
